<template>
  <pdf
    src="/files/AdminPanelAddDevice.pdf"
    v-for="i in 3"
    :key="i"
    :page="i"
  ></pdf>
</template>

<script>
import pdf from "vue3-pdf";
export default {
  components: {
    pdf,
  },
};
</script>

<style></style>
